export default "__VITE_ASSET__DaJsqlqK__"